export const aiFeatureKey = 'ai'
export const conversationFeatureKey = 'ai-conversation'
export const uploadedDocumentIdsKey = 'uploadedDocumentIds'
